import OpenSvg from '@/assets/icons/openOut.svg';
import { clsx } from 'clsx';
import { getFileTypeIcon } from '@/utils/getFileTypeIcon';
import { API_STATIC_FILES } from '@/utils/constants';
import s from './DocumentItem.module.scss';
import { IWithClassname } from '@/models/common';

interface Props extends IWithClassname {
  name: string | null;
  file: string;
  format?: string;
}

export const DocumentItem = ({ name, format, file, className }: Props) => {
  const fileUrl = `${API_STATIC_FILES}${file}`;

  return (
    <div className={clsx(s.document, className)}>
      <a href={fileUrl} target="_blank" rel="noopener noreferrer">
        <div className={s.document__inner}>
          {getFileTypeIcon(format)}
          <p className={s.document__text}>{name}</p>
        </div>
        <button className={s.document__button}>
          Открыть <OpenSvg />
        </button>
      </a>
    </div>
  );
};